import Vue from 'vue';

export const clone = obj => JSON.parse(JSON.stringify(obj));
export const isMobile = () => window.matchMedia('(any-pointer:coarse)').matches;

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

const LOADING_HTML = (title = 'Carregando DANFE...') => `
<!doctype html>
<html lang="pt-BR">
<head>
  <meta charset="utf-8"/>
  <meta name="viewport" content="width=device-width,initial-scale=1"/>
  <title>${title}</title>
  <style>
    :root{
      --zm-red: #DF0914;
      --zm-red-2: #A21018;
      --zm-white: #FCFAFA;
      --bg: #0A0A0D;
      --card: rgba(255,255,255,.06);
      --border: rgba(255,255,255,.10);
      --muted: rgba(252,250,250,.78);
    }
    html,body{height:100%;margin:0;font-family:Inter,system-ui,-apple-system,Segoe UI,Roboto,Arial;background:radial-gradient(1200px 600px at 20% 10%, rgba(223,9,20,.22), transparent 60%), var(--bg);color:var(--zm-white);}
    .wrap{height:100%;display:flex;align-items:center;justify-content:center;padding:24px;}
    .card{
      max-width:560px;width:100%;
      background: linear-gradient(180deg, rgba(223,9,20,.10), rgba(255,255,255,.06));
      border:1px solid rgba(223,9,20,.25);
      border-radius:18px;
      padding:22px 22px;
      box-shadow:0 12px 34px rgba(0,0,0,.45);
      backdrop-filter: blur(10px);
    }
    .row{display:flex;gap:14px;align-items:center;}
    .spinner{
      width:40px;height:40px;border-radius:50%;
      border:3px solid rgba(252,250,250,.18);
      border-top-color: var(--zm-red);
      border-right-color: rgba(223,9,20,.55);
      animation:spin 1s linear infinite;
      box-shadow:0 0 0 6px rgba(223,9,20,.08);
    }
    @keyframes spin{to{transform:rotate(360deg)}}
    .title{font-size:16px;font-weight:800;letter-spacing:.2px;margin:0;}
    .sub{margin:6px 0 0 0;color:var(--muted);line-height:1.35;font-size:13px;}
    .bar{
      height:7px;background:rgba(252,250,250,.10);
      border-radius:999px;overflow:hidden;margin-top:14px;
      border:1px solid rgba(223,9,20,.20);
    }
    .bar > i{
      display:block;height:100%;width:42%;
      background: linear-gradient(90deg, rgba(223,9,20,.15), rgba(223,9,20,.85), rgba(162,16,24,.75));
      border-radius:999px;animation:move 1.15s ease-in-out infinite;
    }
    @keyframes move{0%{transform:translateX(-120%)}100%{transform:translateX(270%)}}
    .hint{margin-top:10px;font-size:12px;color:rgba(252,250,250,.62)}
    .badge{
      margin-top:14px;display:inline-flex;gap:8px;align-items:center;
      padding:8px 10px;border-radius:999px;
      background:rgba(223,9,20,.10);
      border:1px solid rgba(223,9,20,.25);
      color:rgba(252,250,250,.9);
      font-size:12px;
    }
    .dot{width:8px;height:8px;border-radius:50%;background:var(--zm-red);box-shadow:0 0 0 4px rgba(223,9,20,.18);}
  </style>
</head>
<body>
  <div class="wrap">
    <div class="card">
      <div class="row">
        <div class="spinner"></div>
        <div>
          <p class="title">${title}</p>
          <p class="sub">Consultando a nota e preparando a visualização…</p>
        </div>
      </div>
      <div class="bar"><i></i></div>
      <div class="badge"><span class="dot"></span> ZaperMenu Fiscal</div>
      <div class="hint">Se demorar, pode ser instabilidade na SEFAZ, Webmania ou na conexão com a internet.</div>
    </div>
  </div>
</body>
</html>
`;

const ERROR_HTML = (msg = 'Não foi possível carregar a DANFE.') => `
<!doctype html>
<html lang="pt-BR">
<head>
  <meta charset="utf-8"/>
  <meta name="viewport" content="width=device-width,initial-scale=1"/>
  <title>Erro</title>
  <style>
    :root{
      --zm-red: #DF0914;
      --zm-red-2: #A21018;
      --zm-white: #FCFAFA;
      --bg: #0A0A0D;
      --muted: rgba(252,250,250,.78);
    }
    html,body{height:100%;margin:0;font-family:Inter,system-ui,-apple-system,Segoe UI,Roboto,Arial;background:radial-gradient(1100px 520px at 18% 10%, rgba(223,9,20,.25), transparent 60%), var(--bg);color:var(--zm-white);}
    .wrap{height:100%;display:flex;align-items:center;justify-content:center;padding:24px;}
    .card{
      max-width:640px;width:100%;
      background: linear-gradient(180deg, rgba(223,9,20,.12), rgba(255,255,255,.05));
      border:1px solid rgba(223,9,20,.30);
      border-radius:18px;
      padding:22px;
      box-shadow:0 12px 34px rgba(0,0,0,.50);
    }
    .title{margin:0;font-size:16px;font-weight:900;letter-spacing:.2px}
    .sub{margin:10px 0 0 0;color:var(--muted);line-height:1.45;font-size:13px;white-space:pre-wrap}
    .row{display:flex;align-items:center;gap:10px;margin-bottom:8px}
    .icon{
      width:36px;height:36px;border-radius:10px;
      background:rgba(223,9,20,.16);
      border:1px solid rgba(223,9,20,.30);
      display:flex;align-items:center;justify-content:center;
      box-shadow:0 0 0 6px rgba(223,9,20,.08);
    }
    .icon svg{width:18px;height:18px;fill:var(--zm-red)}
    .actions{margin-top:14px;display:flex;gap:10px;flex-wrap:wrap}
    .btn{
      display:inline-block;padding:10px 12px;border-radius:12px;
      background:rgba(223,9,20,.14);
      border:1px solid rgba(223,9,20,.35);
      color:rgba(252,250,250,.95);
      text-decoration:none;font-size:13px;font-weight:700;
      cursor:pointer;
    }
    .btn.secondary{
      background:rgba(252,250,250,.06);
      border:1px solid rgba(252,250,250,.14);
      color:rgba(252,250,250,.9);
    }
    .footer{margin-top:12px;font-size:12px;color:rgba(252,250,250,.55)}
    code{background:rgba(252,250,250,.06);padding:2px 6px;border-radius:8px;border:1px solid rgba(252,250,250,.10)}
  </style>
</head>
<body>
  <div class="wrap">
    <div class="card">
      <div class="row">
        <div class="icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M12 2a10 10 0 1 0 .001 20.001A10 10 0 0 0 12 2Zm1 14h-2v-2h2v2Zm0-4h-2V6h2v6Z"/></svg>
        </div>
        <p class="title">Erro ao carregar DANFE</p>
      </div>
      <p class="sub">${escapeHtml(msg)}</p>
      <div class="actions">
        <button class="btn" onclick="window.location.reload()">Tentar novamente</button>
        <button class="btn secondary" onclick="window.close()">Fechar</button>
      </div>
      <div class="footer">Verifique sua conexão com a internet e tente novamente.</div>
    </div>
  </div>
</body>
</html>
`;

function escapeHtml(str) {
    return String(str ?? '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');
}

function writeToWindow(win, html) {
    if (!win || win.closed) return;
    win.document.open();
    win.document.write(html);
    win.document.close();
}

function getHeader(headers, key) {
    if (!headers) return '';
    return headers[key] || headers[key.toLowerCase()] || headers[key.toUpperCase()] || '';
}

async function extractErrorMessage(err) {
    const defaultMsg = err?.message || 'Falha ao consultar a DANFE.';

    try {
        const blob = err?.response?.data;

        if (blob instanceof Blob) {
            const text = await blob.text();

            try {
                const json = JSON.parse(text);
                return json?.msg || json?.message || defaultMsg;
            } catch (_) {
                return text || defaultMsg;
            }
        }

        if (typeof err?.response?.data === 'string' && err.response.data) {
            try {
                const json = JSON.parse(err.response.data);
                return json?.msg || json?.message || defaultMsg;
            } catch (_) {
                return err.response.data;
            }
        }

        return defaultMsg;
    } catch (_) {
        return defaultMsg;
    }
}

const DANFE_TIMEOUT_MS = 10000;
const WEBMANIA_DANFE_URL = 'https://nfe.webmania.com.br/danfe';

function danfeRef(nota) {
    if (nota && typeof nota === 'object') {
        return {
            id: nota.id,
            urlPublica: nota.danfe || (nota.chave ? `${WEBMANIA_DANFE_URL}/${nota.chave}` : null),
        };
    }

    return { id: nota, urlPublica: null };
}

const fetchDanfe = async id => {
    try {
        const response = await Vue.prototype.$http.get(`fiscal/visualizar-nota/${id}`, {
            responseType: 'blob',
            timeout: DANFE_TIMEOUT_MS,
        });

        const contentType = String(getHeader(response.headers, 'content-type') || '').toLowerCase();

        return {
            ok: true,
            blob: response.data,
            contentType,
        };
    } catch (err) {
        const semResposta = !err?.response;
        const msg = semResposta
            ? 'A DANFE não terminou de carregar.'
            : await extractErrorMessage(err);

        return {
            ok: false,
            msg,
            semResposta,
        };
    }
};

function abrirLinkPublico(win, result, urlPublica) {
    if (result?.ok || !result?.semResposta || !urlPublica || !win || win.closed) {
        return false;
    }

    win.location.replace(urlPublica);
    return true;
}

async function renderDanfeInWindow(win, result) {
    if (!result?.ok || !result?.blob) {
        writeToWindow(win, ERROR_HTML(result?.msg || 'Falha ao consultar a DANFE.'));
        return { ok: false };
    }

    const contentType = String(result.contentType || '').toLowerCase();

    if (contentType.includes('application/pdf')) {
        const blobUrl = URL.createObjectURL(result.blob);
        win.location.replace(blobUrl);

        return {
            ok: true,
            type: 'pdf',
            cleanup: () => {
                setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
            },
        };
    }

    if (
        contentType.includes('text/html') ||
        contentType.includes('text/plain') ||
        !contentType
    ) {
        const html = await result.blob.text();

        if (html && /^%PDF/i.test(html.trim())) {
            const pdfBlob = new Blob([result.blob], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(pdfBlob);
            win.location.replace(blobUrl);

            return {
                ok: true,
                type: 'pdf',
                cleanup: () => {
                    setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
                },
            };
        }

        writeToWindow(win, html);

        return {
            ok: true,
            type: 'html',
        };
    }

    writeToWindow(win, ERROR_HTML(`Formato não suportado para visualização: ${contentType}`));
    return { ok: false };
}

export const openDanfe = async nota => {
    const { id, urlPublica } = danfeRef(nota);
    const win = window.open('', '_blank');

    if (!win) {
        throw new Error('Popup bloqueado. Permita popups para visualizar.');
    }

    writeToWindow(win, LOADING_HTML('Carregando DANFE...'));

    const result = await fetchDanfe(id);

    if (abrirLinkPublico(win, result, urlPublica)) {
        return;
    }

    const rendered = await renderDanfeInWindow(win, result);

    if (rendered?.ok) {
        win.focus();
    }

    if (typeof rendered?.cleanup === 'function') {
        rendered.cleanup();
    }
};

export const printDanfe = async nota => {
    const { id, urlPublica } = danfeRef(nota);
    const win = window.open('', '_blank');

    if (!win) {
        throw new Error('Popup bloqueado. Permita popups para imprimir.');
    }

    writeToWindow(win, LOADING_HTML('Carregando DANFE para impressão...'));

    const result = await fetchDanfe(id);

    if (abrirLinkPublico(win, result, urlPublica)) {
        return;
    }

    const rendered = await renderDanfeInWindow(win, result);

    if (!rendered?.ok) {
        return;
    }

    if (rendered.type === 'html') {
        await sleep(800);
        win.focus();
        win.print();

        await sleep(400);
        if (!win.closed) {
            win.close();
        }
    }

    if (rendered.type === 'pdf') {
        const tryPrintPdf = () => {
            try {
                win.focus();
                win.print();
            } catch (_) {
                //
            }
        };

        setTimeout(tryPrintPdf, 1200);
        setTimeout(tryPrintPdf, 2200);
        setTimeout(tryPrintPdf, 3200);
    }

    if (typeof rendered?.cleanup === 'function') {
        rendered.cleanup();
    }
};
